import React, { useEffect, useState } from "react";
import Box from "../../../elements/box/Box";
import {
  AnnotationIcon,
  DocumentIcon,
  CalendarIcon,
} from "@heroicons/react/outline";
import ChatBox from "../../../parts/chat-box/ChatBox";
import { CSSTransition } from "react-transition-group";
import SMModal from "../../../elements/modals/SMModal";
import ButtonPrimary from "../../../elements/button/ButtonPrimary";
import axiosAPI from "../../../utils/axios-api";
import { Link } from "react-router-dom";
import swal from "sweetalert2";

const API = process.env.REACT_APP_API;
function RespondenBox(props) {

  const [showChat, setShowChat] = useState(false);
  const [modalPersetujuan, setmodalPersetujuan] = useState(null);
  const {
    id,
    code,
    email,
    username,
    judul,
    kode_kuesioner,
    keterangan,
    kuesioner_id,
    nama_institusi,
    nama,
    no_handphone,
    npsn,
    poin,
    responden_pp,
    responden_pr,
    scoin,
    sifat,
    sr,
    status,
    status_jawaban,
    status_scoin,
    tanggal_approval,
    tanggal_buka,
    tanggal_partisipasi,
    tanggal_tutup,
    tipe,
    user_group,
    user_id,
  } = props.data ?? null;

  // State for pembayaran scoin
  const [biaya, setBiaya] = useState(null);
  const [biaya_admin, setBiayaAdmin] = useState(null);
  const [komisi, setKomisi] = useState(null);
  const [total, setTotal] = useState(null);
  const [transaksi_id, setTransaksiId] = useState(null);
  const [set_pecahan_100, setPecahan100] = useState(null);
  const [set_pecahan_1000, setPecahan1000] = useState(null);
  const [set_pecahan_10000, setPecahan10000] = useState(null);
  const [set_pecahan_100000, setPecahan100000] = useState(null);

  const [pecahan100, setPecahans100] = useState(0);
  const [pecahan1000, setPecahans1000] = useState(0);
  const [pecahan10000, setPecahans10000] = useState(0);
  const [pecahan100000, setPecahans100000] = useState(0);

  const [bayarPecahan100, setBayarPecahans100] = useState(0);
  const [bayarPecahan1000, setBayarPecahans1000] = useState(0);
  const [bayarPecahan10000, setBayarPecahans10000] = useState(0);
  const [bayarPecahan100000, setBayarPecahans100000] = useState(0);
  

  function hitungScoin(){
    let tipe_kuesioner = sifat === 0 ? "terbuka" : "tertutup";
    let body = {kode_kuesioner: kode_kuesioner, responden: username, biaya: scoin, type: tipe_kuesioner }
  
    axiosAPI
      .post(API + "scoin/hitung", body)
      .then((res) => {
          if( res.data.status == false ){
            swal.fire('Gagal', res.data.message, 'error')
            setmodalPersetujuan(null);
          }else{
            let data = res.data.data
            setBiaya("SC " + data.biaya ?? 0)
            setBiayaAdmin("SC " + data.biaya_admin ?? 0)
            setKomisi("SC " + data.komisi ?? 0)
            setTotal("SC " + data.total ?? 0)
            setTransaksiId(data.transaksi_id)
            setPecahan100(res.data.data.pecahan_royalti_user[100])
            setPecahan1000(res.data.data.pecahan_royalti_user[1000])
            setPecahan10000(res.data.data.pecahan_royalti_user[10000])
            setPecahan100000(res.data.data.pecahan_royalti_user[100000])
            setmodalPersetujuan(1)
          }
      })
      .catch((xhr) => {
        console.log(xhr)
      });
  }

  function bayarScoin(){

    let dibayar_100 = parseInt(pecahan100)
    let dibayar_1000 = parseInt(pecahan1000)
    let dibayar_10000 = parseInt(pecahan10000)
    let dibayar_100000 = parseInt(pecahan100000)
    let totalall = document.getElementById('totalPembayarannya').textContent

    let totalku = total.replace(/[^0-9]/g, "")
    
    if( parseInt(totalall) <= 0 ){
      document.getElementById('errorpembayaran').innerHTML = 'Masukkan Jumlah Transfer Dengan Benar'
      setmodalPersetujuan(1)
    }else if( parseInt(totalall) !== parseInt(totalku)){
      document.getElementById('errorpembayaran').innerHTML = 'Maaf Jumlah Transfer Tidak Sesuai Dengan Total Bayar'
    }else{

      let pecahan = {
        100: dibayar_100,
        1000: dibayar_1000,
        10000: dibayar_10000,
        100000: dibayar_100000,
      }
      let body = {transaksi_id: transaksi_id, pecahan: pecahan, kuesioner_id: kuesioner_id, responden: id,  tipe: "terbuka"}
    
      axiosAPI
        .post(API + "scoin/bayar", body)
        .then((res) => {
          kirimPersetujuan({ status: 1 }, res.data.message)
        })
        .catch((xhr) => {
          console.log(xhr)
        });

    }

  }

  const handleOnChange100 = (e) => {
    
    let val = parseInt(pecahan100)
    let val1 = parseInt(set_pecahan_100)
    if (e.target.value > val1) {
        setBayarPecahans100(0);
        setPecahans100(0);
        document.getElementById('error100').innerHTML = "Jumlah Transfer Harus Lebih Kecil Dari Jumlah Dimiliki";
        totalPembayaranScoin();
    } else if (e.target.value < 0) {
        setBayarPecahans100(0);
        setPecahans100(0);
        document.getElementById('error100').innerHTML = "Jumlah Transfer Tidak Boleh Kurang Dari 0";
        totalPembayaranScoin();

    } else if (e.target.value === "") {
        setBayarPecahans100(0);
        setPecahans100(0);
        document.getElementById('error100').innerHTML = "Jumlah Transfer Tidak Boleh Kosong";
        totalPembayaranScoin();

    } else {
        setPecahans100(e.target.value)
        let jumlah = e.target.value * 100;
        setBayarPecahans100(jumlah);
        document.getElementById('error100').innerHTML = "";
        totalPembayaranScoin();

    }
    
  }

  const handleOnChange1000 = (e) => {

    let val = parseInt(pecahan1000)
    let val2 = parseInt(set_pecahan_1000)
    if (e.target.value > val2) {
        setBayarPecahans1000(0);
        setPecahans1000(0);
        document.getElementById('error1000').innerHTML = "Jumlah Transfer Harus Lebih Kecil Dari Jumlah Dimiliki";
        totalPembayaranScoin();
    } else if (e.target.value < 0) {
        setBayarPecahans1000(0);
        setPecahans1000(0);
        document.getElementById('error1000').innerHTML = "Jumlah Transfer Tidak Boleh Kurang Dari 0";
        totalPembayaranScoin();

    } else if (e.target.value === "") {
        setBayarPecahans1000(0);
        setPecahans1000(0);
        document.getElementById('error1000').innerHTML = "Jumlah Transfer Tidak Boleh Kosong";
        totalPembayaranScoin();

    } else {
        setPecahans1000(e.target.value)
        let jumlah = e.target.value * 1000;
        setBayarPecahans1000(jumlah);
        document.getElementById('error1000').innerHTML = "";
        totalPembayaranScoin();
    }

  }

  const handleOnChange10000 = (e) => {
    let val = parseInt(pecahan10000)
    let val2 = parseInt(set_pecahan_10000)
    if (e.target.value > val2) {
        setBayarPecahans10000(0);
        setPecahans10000(0);
        document.getElementById('error10000').innerHTML = "Jumlah Transfer Harus Lebih Kecil Dari Jumlah Dimiliki";
        totalPembayaranScoin();
    } else if (e.target.value < 0) {
        setBayarPecahans10000(0);
        setPecahans10000(0);
        document.getElementById('error10000').innerHTML = "Jumlah Transfer Tidak Boleh Kurang Dari 0";
        totalPembayaranScoin();

    } else if (e.target.value === "") {
        setBayarPecahans10000(0);
        setPecahans10000(0);
        document.getElementById('error10000').innerHTML = "Jumlah Transfer Tidak Boleh Kosong";
        totalPembayaranScoin();

    } else {
        setPecahans10000(e.target.value)
        let jumlah = e.target.value * 10000;
        setBayarPecahans10000(jumlah);
        document.getElementById('error100000').innerHTML = "";
        totalPembayaranScoin();
    }

  }

  const handleOnChange100000 = (e) => {
    let val = parseInt(pecahan100000)
    let val2 = parseInt(set_pecahan_100000)
    if (e.target.value > val2) {
        setBayarPecahans100000(0);
        setPecahans100000(0);
        document.getElementById('error100000').innerHTML = "Jumlah Transfer Harus Lebih Kecil Dari Jumlah Dimiliki";
        totalPembayaranScoin();
    } else if (e.target.value < 0) {
        setBayarPecahans100000(0);
        setPecahans100000(0);
        document.getElementById('error100000').innerHTML = "Jumlah Transfer Tidak Boleh Kurang Dari 0";
        totalPembayaranScoin();

    } else if (e.target.value === "") {
        setBayarPecahans100000(0);
        setPecahans100000(0);
        document.getElementById('error100000').innerHTML = "Jumlah Transfer Tidak Boleh Kosong";
        totalPembayaranScoin();

    } else {
        setPecahans100000(e.target.value)
        let jumlah = e.target.value * 100000;
        setBayarPecahans100000(jumlah);
        document.getElementById('error100000').innerHTML = "";
        totalPembayaranScoin();
    }

  }

  function totalPembayaranScoin() {
    let val100 = bayarPecahan100
    let val1000 = bayarPecahan1000
    let val10000 = bayarPecahan10000
    let val100000 = bayarPecahan100000
    let totalnya = val100 + val1000 + val10000 + val100000
    
    return totalnya
  }

  function renderPP(params) {
    if (responden_pp === "menunggu") {
      return (
        <>
          <button
            // onClick={() => kirimPersetujuan({ status: 1, id: id })}
            // onClick={() => setmodalPersetujuan(1)}
            onClick={() => hitungScoin()}
            className="py-1 mr-1 my-2 px-4 rounded-full bg-blue-500 text-white dark:text-white text-sm"
          >
            Terima
          </button>
          <button
            onClick={() => setmodalPersetujuan(2)}
            className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm"
          >
            Tolak
          </button>
        </>
      );
    } else if (responden_pp === "diterima") {
      return (
        <button className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-green-500 text-green-600 dark:text-white text-sm">
          Diterima
        </button>
      );
    } else if (responden_pp === "diterima") {
      return (
        <button className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-green-500 text-green-600 dark:text-white text-sm">
          Ditolak
        </button>
      );
      
    } else {
      return (
        <button className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-green-500 text-green-600 dark:text-white text-sm">
          -
        </button>
      );
    }
  }
  // console.log(responden_pr)
  function renderPR(params) {
    if (responden_pr === "diterima") {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
          Diterima
        </span>
      );
    } else if (responden_pr === "ditolak") {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-red-500 text-red-600 dark:text-white text-sm">
          Ditolak
        </span>
      );
    } else {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
          -
        </span>
      );
    }
  }

  function renderSR(params) {
    if (sr === 1) {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
          OK
        </span>
      );
    } else {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
          -
        </span>
      );
    }
  }

  function renderModalPersetujuan(params) {

    function renderSetuju(params) {

      return (
        <div className="flex flex-col px-4">
          <p className="my-2">Yakin ingin menyetujui?</p>
          <div className="flex flex-row mt-2 gap-2">
            <ButtonPrimary
              // onClick={() => kirimPersetujuan({ status: 1 })}
              onClick={() => bayarScoin()}
              text="Terima"
              type="solid"
            />
            <ButtonPrimary
              onClick={() => setmodalPersetujuan(null)}
              text="Batal"
              type="outline"
            />
          </div>
        </div>
      );
    }

    function renderTolak(params) {
      return (
        <div className="flex flex-col px-4">
          <p className="my-2">Yakin ingin menolak?</p>
          <div className="flex flex-row mt-2 gap-2">
            <ButtonPrimary
              onClick={() => kirimPersetujuan({ status: 0 })}
              text="Ya"
              type="solid"
            />
            <ButtonPrimary
              onClick={() => setmodalPersetujuan(null)}
              text="Batal"
              type="outline"
            />
          </div>
        </div>
      );
    }

    return (
      <SMModal
        total="Persetujuan"
        show={!!modalPersetujuan}
        onClose={() => setmodalPersetujuan(null)}
      >
        
        {/* Table rincian pembayaran */}
        <div className="flex flex-col justify-center h-full">
            <div className="w-full max-w-2xl mx-auto bg-white shadow-lg rounded-sm border border-gray-200">
                <div className="p-3">
                    <div className="overflow-x-auto">
                        <table className="table-auto w-full table-bordered">
                            <thead className="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
                                <tr>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left">Biaya</div>
                                    </th>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left" id="biaya">{biaya}</div>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left">Biaya Admin</div>
                                    </th>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left" id="biaya_admin">{biaya_admin}</div>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left">Komisi</div>
                                    </th>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left" id="komisi">{komisi}</div>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left">Total Bayar</div>
                                    </th>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left" id="total_bayar">{total}</div>
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        
        {/* Table Scoin yang dimiliki / pembayaran */}
        <div className="flex flex-col justify-center h-full mt-5">
            <div className="w-full max-w-2xl mx-auto bg-white shadow-lg rounded-sm border border-gray-200">
                <div className="p-3">
                    <div className="overflow-x-auto">
                        <table className="table-auto w-full">
                            <thead className="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
                                <tr>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left">Jenis</div>
                                    </th>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left">Dimiliki</div>
                                    </th>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-left">Ditransfer</div>
                                    </th>
                                    <th className="p-2 whitespace-nowrap">
                                        <div className="font-semibold text-center">Jumlah</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="text-sm divide-y divide-gray-100">
                                <tr>
                                    <td className="p-2 whitespace-nowrap">
                                        <div className="flex items-center">
                                            <div className="font-medium text-gray-800">100 Sc</div>
                                        </div>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                        <div className="text-left">{set_pecahan_100}</div>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                    <input 
                                    className="shadow appearance-none border border-grey-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" 
                                    id="ditransfer_100"
                                    type="number"
                                    value={pecahan100}
                                    onChange={handleOnChange100}
                                    />
                                    <p className="text-sm text-red-700" id="error100"></p>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                    <input
                                    className="shadow appearance-none border border-grey-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                                    id="jumlah_100"
                                    type="number"
                                    readOnly
                                    value={bayarPecahan100} />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="p-2 whitespace-nowrap">
                                        <div className="flex items-center">
                                            <div className="font-medium text-gray-800">1000 Sc</div>
                                        </div>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                        <div className="text-left">{set_pecahan_1000}</div>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                    <input
                                    class="shadow appearance-none border border-grey-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                                    id="ditransfer_1000"
                                    type="number"
                                    value={pecahan1000}
                                    onChange={handleOnChange1000} />
                                    <p className="text-sm text-red-700" id="error1000"></p>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                    <input
                                    className="shadow appearance-none border border-grey-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                                    id="jumlah_1000"
                                    type="number"
                                    readOnly
                                    value={bayarPecahan1000} />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="p-2 whitespace-nowrap">
                                        <div className="flex items-center">
                                            <div className="font-medium text-gray-800">10000 Sc</div>
                                        </div>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                        <div className="text-left">{set_pecahan_10000}</div>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                    <input
                                    className="shadow appearance-none border border-grey-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                                    id="ditransfer_10000"
                                    type="number"
                                    value={pecahan10000}
                                    onChange={handleOnChange10000} />
                                    <p className="text-sm text-red-700" id="error10000"></p>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                    <input
                                    className="shadow appearance-none border border-grey-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                                    id="jumlah_10000"
                                    type="number"
                                    readOnly
                                    value={bayarPecahan10000} />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="p-2 whitespace-nowrap">
                                        <div className="flex items-center">
                                            <div className="font-medium text-gray-800">100000 Sc</div>
                                        </div>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                        <div className="text-left">{set_pecahan_100000}</div>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                    <input
                                    className="shadow appearance-none border border-grey-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                                    id="ditransfer_100000"
                                    type="number"
                                    value={pecahan100000}
                                    onChange={handleOnChange100000} />
                                    <p className="text-sm text-red-700" id="error100000"></p>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">
                                      <input
                                      className="shadow appearance-none border border-grey-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                                      id="jumlah_100000"
                                      type="number"
                                      readOnly
                                      value={bayarPecahan100000} />
                                    </td>
                                </tr>


                                <tr>
                                    <td className="p-2 whitespace-nowrap text-center" colSpan="3">
                                        <div className="font-medium text-gray-800">Total</div>
                                    </td>
                                    <td className="p-2 whitespace-nowrap" id="totalPembayarannya">
                                      {totalPembayaranScoin()}
                                    </td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <p className="text-sm text-red-700" id="errorpembayaran"></p>

        <div className="font-semibold text-left">
            {modalPersetujuan === 1 ? renderSetuju() : renderTolak()}
        </div>
      </SMModal>
    );
  }

  function kirimPersetujuan(params, message) {
    let body = { status: params.status };
    axiosAPI
      .post(API + "responden/" + id + "/persetujuan-pendaftaran", body)
      .then((res) => {
        setmodalPersetujuan(null);
        if( res.data.status == "success" ){
          swal.fire('Berhasil', message + ', ' + res.data.message, 'success')
        }else{
          swal.fire('Gagal', message + ', ' + res.data.message, 'error')
        }
        props.onRefresh();
      });
  }

  return (
    <div className="flex flex-row gap-4">
      {renderModalPersetujuan()}
      <Box>
        <div className="flex flex-col">
          <div className="flex flex-row">
            <div className="w-10/12">
              <div className="flex flex-row items-center">
                <div className="flex-1 flex flex-col">
                  <h1 className="text-2xl font-bold">{judul}</h1>
                  <div className="flex flex-row gap-8 items-center mt-4">
                    <div className="flex flex-row gap-2 items-center">
                      <DocumentIcon className="h-4 w-4 text-blue-500" />
                      <p className="text-sm text-blue-500">{kuesioner_id}</p>
                    </div>

                    <div className="flex flex-row gap-2 items-center">
                      <CalendarIcon className="h-4 w-4 text-blue-500" />
                      <p className="text-sm text-blue-500">
                        {tanggal_buka.replace(/-/g, "/")}
                      </p>
                      <p>-</p>
                      <p className="text-sm text-blue-500">
                        {tanggal_tutup.replace(/-/g, "/")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex py-6 flex-col">
                <h1 className="text-lg font-semibold">
                  Nama partisipan <span className="font-normal">{nama}</span>
                </h1>
                <h1 className="text-lg font-semibold">
                  Institusi{" "}
                  <span className="font-normal">{nama_institusi ?? "-"}</span>
                </h1>
                {/* <p className="text-xs mt-6">
                  {keterangan.substr(0, 80)}
                </p> */}
              </div>
            </div>
            <div className="w-2/12 flex flex-col items-end gap-2">
              {/* <button onClick={() => setShowChat(!showChat)}>
                <AnnotationIcon className="h-8 w-8" />
              </button> */}
              <span className="py-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 font-bold text-sm">
                {poin} Poin
              </span>
              <span className="py-2 px-4 rounded bg-yellow-100 dark:bg-yellow-100 text-yellow-600 dark:text-yellow-900 font-bold text-sm">
                {scoin} Scoin
              </span>
            </div>
          </div>
          <div className="flex flex-col">
            {/* <div className="flex flex-row items-center">
              <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                Terbuka
              </span>
              <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                Likert
              </span>
              <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                Panduan
              </span>
              <span className="py-2 px-4 rounded bg-yellow-100 dark:bg-yellow-100 my-2 text-yellow-600 dark:text-yellow-900 font-bold text-sm">
                50000
              </span>
            </div> */}

            <div className="flex flex-row justify-between">
              <div className="flex flex-row gap-2">
                <div className="flex flex-col items-center gap-2 px-4 bg-gray-200 dark:bg-gray-700 py-2 rounded">
                  <p className="text-sm">Persetujuan Pendaftaran</p>
                  <div className="flex flex-row justify-between">
                    {renderPP()}
                  </div>
                </div>

                <div className="flex flex-col items-center gap-2 bg-gray-200 dark:bg-gray-700 px-4 py-2 rounded">
                  <p className="text-sm">PR</p>
                  {renderPR()}
                </div>
                <div className="flex flex-col items-center gap-2 bg-gray-200 dark:bg-gray-700 px-4 py-2 rounded">
                  <p className="text-sm">SR</p>
                  {renderSR()}
                </div>
              </div>

              <div className="flex flex-row gap-2 items-center justify-end">
                {/* {renderButtonIsi()} */}
                <Link to={`/hasil-kuesioner/${kuesioner_id}`}>
                  <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg border bg-blue-500 text-white">
                    <p className="text-sm">Hasil</p>
                  </button>
                </Link>

                {/* <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg border border-blue-500 text-blue-500">
                  <p className="text-sm">Bayar</p>
                </button>
                <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg border border-blue-500 text-blue-500">
                  <p className="text-sm">Return</p>
                </button> */}
                <button
                  onClick={() => setShowChat(!showChat)}
                  className="justify-center px-4 py-2 flex flex-row items-center rounded-lg border border-blue-500 text-blue-500"
                >
                  <p className="text-sm">Chat</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Box>
      {showChat ? (
        <CSSTransition
          in={showChat}
          timeout={200}
          classNames="anm-partisipasi-chat"
        >
          <div
            className="my-4 shadow-xl flex rounded-lg border border-gray-300 dark:border-gray-700 overflow-hidden"
            style={{ minWidth: "500px" }}
          >
            <ChatBox id={id} type="responden" />
          </div>
        </CSSTransition>
      ) : null}
    </div>
  );
}

RespondenBox.propTypes = {};

export default RespondenBox;
